import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Especialidade } from '../../../especialidade/especialidade';
import { EspecialidadeService } from '../../../especialidade/especialidade.service';
import { ChaveValorStrInterface } from '../../../util/chave-valor-str-interface';
import { Util } from '../../../util/util';
import { ProcedimentoConsulta } from '../procedimento-consulta';
import { ProcedimentoConsultaService } from '../procedimento-consulta.service';

@Component({
  selector: 'app-procedimento-consulta-maintenance',
  templateUrl: './procedimento-consulta-maintenance.component.html',
  styleUrls: ['./procedimento-consulta-maintenance.component.css']
})
export class ProcedimentoConsultaMaintenanceComponent implements OnInit {

  id: number;

  isUpdate: string;

  isInfo: boolean = false;

  procedimentoConsulta: ProcedimentoConsulta;

  formularioProcedimentoConsulta: FormGroup;

  tituloCrud: string = '';

  public listaTipoAgendamento: ChaveValorStrInterface[];

  public listaEspecialidades: Especialidade[];

  constructor(private procedimentoConsultaService: ProcedimentoConsultaService,
    private especialidadeService: EspecialidadeService,
    private router: Router,
    private formBuilder: FormBuilder,
    private cd: ChangeDetectorRef) {

    this.id = history.state.id;
    this.isUpdate = history.state.isUpdate;

    this.procedimentoConsulta = new ProcedimentoConsulta();

    this.formularioProcedimentoConsulta = this.formBuilder.group({
      id: 0,
      especialidade: ['', [Validators.required]],
      nome: ['', [Validators.required, Validators.minLength(5)]],
      tipoAgendamento: ['', Validators.required],
      disponivel: new FormControl(false),
      valor: [0, Validators.required],
      apelido: ['', [Validators.required, Validators.minLength(3)]],
      observacao: [''],
      cobrarProcedimento: false,
      tipoAgendamentoFormatado: '',
      disponivelFormatado: ''
    });

    this.listaTipoAgendamento = Util.listaTipoAgendamento;

    this.listaEspecialidades = [];
  }

  ngOnInit() {

    if (this.id) {
      if (this.isUpdate == 'S') {
        this.tituloCrud = 'Alterar Sub-Especialidade';
      } else {
        this.isInfo = true;
        this.tituloCrud = 'Detalhe Sub-Especialidade';
      }
    } else {
      this.tituloCrud = 'Criar Sub-Especialidade';
    }

    this.listarEpecialidades();
  }

  save() {

    this.procedimentoConsulta = this.formularioProcedimentoConsulta.value;

    if (!this.procedimentoConsulta.disponivel) {
      this.procedimentoConsulta.disponivel = false;
    }

    if (this.isNew()) {
      this.procedimentoConsultaService
        .criar(this.procedimentoConsulta).subscribe(data => {
          // console.log(data)

          this.gotoList();
        }, error => {
          console.log(error);
        });
    } else {
      this.procedimentoConsultaService.atualizar(this.procedimentoConsulta, this.id)
        .subscribe(data => {
          // console.log(data); 

          this.gotoList();
        }, error => {
          console.log(error);
        });
    }
  }

  onSubmit() {
    this.save();
  }

  gotoList() {
    this.router.navigate(['/procedimentoConsulta']);
  }

  isNew(): boolean {
    return this.id == null || this.id == 0;
  }

  get formControl() {
    return this.formularioProcedimentoConsulta.controls;
  }

  listarEpecialidades() {
    this.especialidadeService.listar()
      .subscribe(data => {
        // console.log(data)
        this.listaEspecialidades = data;

        this.configurarForm();
      }, error => {
        console.log(error);
      });
  }

  configurarForm(): void {
    if (!this.isNew()) {
      this.procedimentoConsulta = history.state.procedimentoConsulta;
      if (this.procedimentoConsulta) {
        this.formularioProcedimentoConsulta.setValue(this.procedimentoConsulta);

        let currentEspecialidade = this.listaEspecialidades.filter(espec => espec.id == this.procedimentoConsulta.especialidade.id)[0];
        this.formularioProcedimentoConsulta.controls.especialidade.patchValue(currentEspecialidade);

        let currentTipoAgendamento = this.listaTipoAgendamento.filter(tipoAgendamento => tipoAgendamento.codigo == this.procedimentoConsulta.tipoAgendamento)[0];
        this.formularioProcedimentoConsulta.controls.tipoAgendamento.patchValue(currentTipoAgendamento.codigo);

        this.cd.detectChanges();

        if (this.isUpdate == 'N') {
          this.formularioProcedimentoConsulta.disable();
        }
      }
    } else {
      this.formularioProcedimentoConsulta.setValue({
        id: 0,
        especialidade: '',
        nome: '',
        tipoAgendamento: '',
        disponivel: '',
        valor: '',
        apelido: '',
        observacao: '',
        cobrarProcedimento: false,
        tipoAgendamentoFormatado: '',
        disponivelFormatado: ''
      });
    }
  }
}
